"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlIVec4Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl int32 vector4 uniform.
 */
class GlIVec4Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniform4iv(this.uniformLocation, data);
        this.isDirty = false;
    }
}
exports.GlIVec4Uniform = GlIVec4Uniform;
//# sourceMappingURL=gl-i-vec4-uniform.js.map